module.exports = __webpack_public_path__ + "static/media/24UHCHR21.c8a7938b.jpg";